// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type ApiKeyCreateResponse,
  ApiKeyCreateResponseFromJSON,
  ApiKeyCreateResponseToJSON,
} from "../models/ApiKeyCreateResponse";
import {
  type ApiKeyCreateV2,
  ApiKeyCreateV2FromJSON,
  ApiKeyCreateV2ToJSON,
} from "../models/ApiKeyCreateV2";
import { type ApiKeyRead, ApiKeyReadFromJSON, ApiKeyReadToJSON } from "../models/ApiKeyRead";
import {
  type ApiKeyUpdate,
  ApiKeyUpdateFromJSON,
  ApiKeyUpdateToJSON,
} from "../models/ApiKeyUpdate";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PageApiKeyRead,
  PageApiKeyReadFromJSON,
  PageApiKeyReadToJSON,
} from "../models/PageApiKeyRead";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface ApiKeyCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  apiKeyCreateV2: ApiKeyCreateV2;
}

export interface ApiKeyDeleteRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  apiKeyId: string;
}

export interface ApiKeyGetRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  apiKeyId: string;
}

export interface ApiKeyListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: ApiKeyListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   * Filter by related entity type
   */
  relatedToType?: ApiKeyListRelatedToTypeEnum;
  /**
   * Filter by related entity ID
   */
  relatedToId?: string | null;
}

export interface ApiKeyUpdateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  apiKeyId: string;
  /**
   *
   */
  apiKeyUpdate: ApiKeyUpdate;
}

/**
 *
 */
export class ApiKeysApi extends runtime.BaseAPI {
  /**
   * Creates request options for apiKeyCreate without sending the request
   */
  async apiKeyCreateRequestOpts(
    requestParameters: ApiKeyCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling apiKeyCreate().'
      );
    }

    if (requestParameters["apiKeyCreateV2"] == null) {
      throw new runtime.RequiredError(
        "apiKeyCreateV2",
        'Required parameter "apiKeyCreateV2" was null or undefined when calling apiKeyCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
        "publication_manage",
        "project_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/api-keys`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ApiKeyCreateV2ToJSON(requestParameters["apiKeyCreateV2"]),
    };
  }

  /**
   * Create a new API key for a publication, project, or tenant.
   * create an api key
   */
  async apiKeyCreateRaw(
    requestParameters: ApiKeyCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiKeyCreateResponse>> {
    const requestOptions = await this.apiKeyCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ApiKeyCreateResponseFromJSON(jsonValue)
    );
  }

  /**
   * Create a new API key for a publication, project, or tenant.
   * create an api key
   */
  async apiKeyCreate(
    requestParameters: ApiKeyCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiKeyCreateResponse> {
    const response = await this.apiKeyCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiKeyDelete without sending the request
   */
  async apiKeyDeleteRequestOpts(
    requestParameters: ApiKeyDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling apiKeyDelete().'
      );
    }

    if (requestParameters["apiKeyId"] == null) {
      throw new runtime.RequiredError(
        "apiKeyId",
        'Required parameter "apiKeyId" was null or undefined when calling apiKeyDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
        "publication_manage",
        "project_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/api-keys/{api_key_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{api_key_id}",
      encodeURIComponent(String(requestParameters["apiKeyId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete an API key.
   * delete api key
   */
  async apiKeyDeleteRaw(
    requestParameters: ApiKeyDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.apiKeyDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete an API key.
   * delete api key
   */
  async apiKeyDelete(
    requestParameters: ApiKeyDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.apiKeyDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for apiKeyGet without sending the request
   */
  async apiKeyGetRequestOpts(requestParameters: ApiKeyGetRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling apiKeyGet().'
      );
    }

    if (requestParameters["apiKeyId"] == null) {
      throw new runtime.RequiredError(
        "apiKeyId",
        'Required parameter "apiKeyId" was null or undefined when calling apiKeyGet().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
        "publication_manage",
        "project_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/api-keys/{api_key_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{api_key_id}",
      encodeURIComponent(String(requestParameters["apiKeyId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a single API key. Requests using an API key can retrieve themselves, otherwise manage permission is required.
   * get api key
   */
  async apiKeyGetRaw(
    requestParameters: ApiKeyGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiKeyRead>> {
    const requestOptions = await this.apiKeyGetRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiKeyReadFromJSON(jsonValue));
  }

  /**
   * Return a single API key. Requests using an API key can retrieve themselves, otherwise manage permission is required.
   * get api key
   */
  async apiKeyGet(
    requestParameters: ApiKeyGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiKeyRead> {
    const response = await this.apiKeyGetRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiKeyList without sending the request
   */
  async apiKeyListRequestOpts(requestParameters: ApiKeyListRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling apiKeyList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["relatedToType"] != null) {
      queryParameters["related_to_type"] = requestParameters["relatedToType"];
    }

    if (requestParameters["relatedToId"] != null) {
      queryParameters["related_to_id"] = requestParameters["relatedToId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
        "publication_manage",
        "project_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/api-keys`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list of API keys filtered by related entity. Requires related_entity_id and related_entity_type as query parameters.
   * list api keys
   */
  async apiKeyListRaw(
    requestParameters: ApiKeyListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageApiKeyRead>> {
    const requestOptions = await this.apiKeyListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageApiKeyReadFromJSON(jsonValue));
  }

  /**
   * Return a list of API keys filtered by related entity. Requires related_entity_id and related_entity_type as query parameters.
   * list api keys
   */
  async apiKeyList(
    requestParameters: ApiKeyListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageApiKeyRead> {
    const response = await this.apiKeyListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for apiKeyUpdate without sending the request
   */
  async apiKeyUpdateRequestOpts(
    requestParameters: ApiKeyUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling apiKeyUpdate().'
      );
    }

    if (requestParameters["apiKeyId"] == null) {
      throw new runtime.RequiredError(
        "apiKeyId",
        'Required parameter "apiKeyId" was null or undefined when calling apiKeyUpdate().'
      );
    }

    if (requestParameters["apiKeyUpdate"] == null) {
      throw new runtime.RequiredError(
        "apiKeyUpdate",
        'Required parameter "apiKeyUpdate" was null or undefined when calling apiKeyUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
        "publication_manage",
        "project_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/tenants/{tenant_id}/api-keys/{api_key_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{api_key_id}",
      encodeURIComponent(String(requestParameters["apiKeyId"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: ApiKeyUpdateToJSON(requestParameters["apiKeyUpdate"]),
    };
  }

  /**
   * Update an API key.
   * update api key
   */
  async apiKeyUpdateRaw(
    requestParameters: ApiKeyUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ApiKeyRead>> {
    const requestOptions = await this.apiKeyUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ApiKeyReadFromJSON(jsonValue));
  }

  /**
   * Update an API key.
   * update api key
   */
  async apiKeyUpdate(
    requestParameters: ApiKeyUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ApiKeyRead> {
    const response = await this.apiKeyUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ApiKeyListOrderByEnum = {
  Id: "id",
  Id2: "-id",
  CreatedAt: "created_at",
  CreatedAt2: "-created_at",
} as const;
export type ApiKeyListOrderByEnum =
  (typeof ApiKeyListOrderByEnum)[keyof typeof ApiKeyListOrderByEnum];
/**
 * @export
 */
export const ApiKeyListRelatedToTypeEnum = {
  Publication: "publication",
  Project: "project",
  Tenant: "tenant",
} as const;
export type ApiKeyListRelatedToTypeEnum =
  (typeof ApiKeyListRelatedToTypeEnum)[keyof typeof ApiKeyListRelatedToTypeEnum];
